// src/components/RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children, role }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  // Attendre le profil
  if (loading) return null;

  // Pas connecté → aller à /login en gardant la destination
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  // Si une role est requis, vérifier et rediriger selon le rôle réel
  const actualRole = profile?.role || "guest";
  // Admin doit pouvoir accéder à toutes les pages protégées
  if (actualRole === "admin") {
    return children;
  }
  if (role && actualRole !== role) {
    // Redirection cohérente selon le rôle de l’utilisateur
    switch (actualRole) {
      case "eleve":
        return <Navigate to="/eleve" replace />;
      case "prof":
        return <Navigate to="/prof" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  // Autorisé
  return children;
}
